import { Users } from "lucide-react";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/clientWeb/components/ui/dropdown-menu";
import { ControlButton } from "../common/ControlButton";
import { TrackedDropdownMenu } from "../common/TrackedDropdownMenu";
import { useTranslation } from "@/clientWeb/i18n/LanguageContext";

interface ParticipantsDropdownProps {
  participantsOn: boolean;
  webinarUsersOn?: boolean;
  onToggleParticipants: () => void;
  onToggleWebinarUsers?: () => void;
}

export function ParticipantsDropdown({
  participantsOn,
  webinarUsersOn,
  onToggleParticipants,
  onToggleWebinarUsers,
}: ParticipantsDropdownProps) {
  const t = useTranslation();
  return (
    <TrackedDropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="relative">
          <ControlButton active={participantsOn || webinarUsersOn} onClick={() => { }} label={t("controlBar.participants")}>
            <Users className="h-5 w-5 text-white" />
          </ControlButton>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onSelect={() => {
            onToggleParticipants();
          }}
          className="gap-3"
        >
          <Users className="h-4 w-4" />
          <span>{t("controlBar.participants")}</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => {
            onToggleWebinarUsers?.();
          }}
          className="gap-3"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <span>{t("controlBar.webinarUsers")}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </TrackedDropdownMenu>
  );
}
